export default () => [
  {
    name: 'sports',
    group: '',
    routeParams: {
      name: 'Sports',
      query: {
        'bt-path': '/live',
      },
    },
    mobileImg: 'sports-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'bets',
    positionMenu: 1,
    positionNavMob: 1,
  },
  {
    name: 'slots',
    group: 'slot',
    routeParams: {
      name: 'GamesByGroup',
      params: { group: 'slot' },
    },
    mobileImg: 'casino-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'games',
    positionMenu: 6,
    positionNavMob: 2,
  },
  {
    name: 'live_casino',
    group: 'online',
    routeParams: {
      name: 'GamesByGroup',
      params: {
        group: 'online',
      },
    },
    mobileImg: 'live-casino-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'games',
    positionMenu: 6,
    positionNavMob: 4,
  },
  {
    name: 'virtuals',
    group: 'vsport',
    routeParams: {
      name: 'GamesByGroup',
      params: {
        group: 'vsport',
      },
    },
    mobileImg: 'virtuals-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'games',
    positionMenu: 10,
    positionNavMob: 6,
  },
  {
    name: 'table',
    group: 'table',
    routeParams: {
      name: 'GamesByGroup',
      params: {
        group: 'table',
      },
    },
    mobileImg: 'table-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'games',
    positionMenu: 9,
    positionNavMob: 7,
  },
  {
    name: 'lottery',
    group: 'lottery',
    routeParams: {
      name: 'GamesByGroup',
      params: {
        group: 'lottery',
      },
    },
    mobileImg: 'lottery-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'games',
    positionMenu: 8,
    positionNavMob: 8,
  },
  {
    name: 'promo',
    group: 'promo',
    routeParams: {
      name: 'Promo',
      params: {
        type: 'all',
      },
    },
    mobileImg: 'promo-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'promo',
    positionMenu: 5,
    positionNavMob: null,
  },
  {
    name: 'JetX',
    group: '',
    routeParams: {
      name: 'GamePageNew',
      params: {
        game: 'smartsoft-jetx',
        manufacturer: 'smartsoft',
      },
    },
    mobileImg: 'free-speed',
    showInMobileNav: true,
    showInHeader: true,
    type: 'games',
    positionMenu: 3,
    positionNavMob: 8,
  },
  {
    name: 'tournaments',
    group: '',
    routeParams: {
      name: 'Competitions',
      params: {
        type: 'now',
      },
      query: {
        'redirect-on-empty': true,
      },
    },
    mobileImg: 'tournaments-mobile',
    showInMobileNav: false,
    showInHeader: true,
    type: 'competitions',
    positionMenu: 5,
    positionNavMob: null,
  },
  {
    name: 'Aviator',
    group: 'aviator',
    routeParams: {
      name: 'GamePageNew',
      params: {
        game: 'spribe-aviator',
        manufacturer: 'spribe',
      },
    },
    mobileImg: 'aviator-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'game',
    positionMenu: 2,
    positionNavMob: 10,
  },
  {
    name: 'Betgames',
    group: 'betgames',
    routeParams: {
      name: 'GamePageNew',
      params: {
        game: 'warofbetsbg',
        manufacturer: 'bg',
      },
    },
    mobileImg: 'betgames-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'game',
    positionMenu: 4,
    positionNavMob: 9,
  },
  {
    name: 'instant',
    group: 'fast',
    routeParams: {
      name: 'GamesByGroup',
      params: {
        group: 'fast',
      },
    },
    mobileImg: 'instant-mobile',
    showInMobileNav: true,
    showInHeader: true,
    type: 'games',
    positionMenu: 7,
    positionNavMob: 5,
  },
]
